export const formatDate = (UTCDateString, format = 'short') => {
    const UTCDate = new Date(UTCDateString);

    if (format === 'short') {
        //September 20, 2023
        //Sep 20, 23
        let year = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(UTCDate);
        let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(UTCDate);
        let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(UTCDate);
        return `${month} ${day}, ${year}`;
    }
    let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(UTCDate);
    let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(UTCDate);
    let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(UTCDate);
    return `${month} ${day}, ${year}`;
};
